import PropTypes from "prop-types";
import React from "react";
import styles from "css/modules/LoadingCover.css";
import { connect } from "react-redux";
import generateImageLink from "../utils/generateImageLink";

const LoadingCoverComponent = (props) => {
  if (props.loadingImage) {
    const style = {
      height: "100%",
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
    };

    return (
      <div style={props.loadingImageStyle}>
        <img alt="" src={generateImageLink(props.loadingImage)} style={style} />
      </div>
    );
  }
  return <div className={styles.root} />;
};

LoadingCoverComponent.propTypes = {
  loadingImage: PropTypes.string,
  loadingImageStyle: PropTypes.object,
};

export default connect((state) => ({
  loadingImage: state.playerOptions.loadingImage,
  loadingImageStyle: state.playerOptions.loadingImageStyle,
}))(LoadingCoverComponent);
